import { canValidateOpgavekompleksetTask } from '@utils/component-framework';
import { getTaskEntryState } from '../../utils/get-task-entry-state.js';
import { shouldShowFeedback } from '../util.should-show-feedback.js';

function makeSelectTaskState(component) {
  return taskEntry => {
    const task = component.tasks.find(it => it.id === taskEntry?.id);
    const hasValidated = taskEntry?.state.validated ?? false;
    const isCorrect = getTaskEntryState(taskEntry?.stats) === "correct";
    const canValidate = canValidateOpgavekompleksetTask(task);
    const remainingAttempts = component.settings.allowedAttempts - (taskEntry?.state.attempts ?? 0);
    if (shouldShowFeedback(component.settings.flowType) && (remainingAttempts === 0 || isCorrect && hasValidated)) {
      return canValidate ? "facit" : "readonly";
    }
    return "input";
  };
}

export { makeSelectTaskState };
//# sourceMappingURL=task.get-state.js.map
